import {Distribution} from "../model/EstateFlowchartTypes";
import {NavItem} from "../components/FormNav/NavItem";
import {NavItemType} from "../components/FormNav/NavItemType";

export const createNavConfig = (pageConfig : NavItem[], linkConfig: any) => {
    return pageConfig.map((navItem, pageIndex) => {
        let children = undefined;
        if(linkConfig) {
            const distributions = linkConfig[navItem.id] as Distribution[] || [];
            children = distributions && (createNavLinks(distributions, navItem, pageIndex) || undefined);
        }

        const parent: NavItem = {
            type: navItem.type,
            id: navItem.id,
            displayName: navItem.displayName,
            index: navItem.index,
            pathTemplate: navItem.pathTemplate,
            children
        }
        return parent;
    }) ?? [];
}

const createNavLinks = (distributions: Distribution[], navItemPage: NavItem, pageIndex: number) => {
    return distributions.map((distribution: Distribution, linkIndex) => {
        const child: NavItem = {
            type: NavItemType.LINK,
            id: `page${pageIndex}-link${linkIndex}`,
            displayName: distribution?.name ?? "",
            index: linkIndex,
            parent: navItemPage
        }
        return child;
    }) ?? [];
}